import { RefObject, useLayoutEffect } from "react"

import styles from "./gradient_band.module.scss"

// Paints the IFTTT.ai header gradient across the DIY header and the block under it,
// as one band: both draw the same image at the full band height.
export function useGradientBand(blockRef: RefObject<HTMLElement | null>, enabled: boolean) {
  useLayoutEffect(() => {
    const block = blockRef.current
    const header = block?.closest(".container.web")?.querySelector<HTMLElement>("header")
    if (!enabled || !block || !header) return

    const paint = () => {
      const height = `${header.offsetHeight + block.offsetHeight}px`
      header.style.setProperty("--gradient-band-height", height)
      block.style.setProperty("--gradient-band-height", height)
      block.style.setProperty("--gradient-band-offset", `-${header.offsetHeight}px`)
    }

    header.classList.add(styles.band)
    block.classList.add(styles.band)
    paint()
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(paint)
    observer?.observe(header)
    observer?.observe(block)

    return () => {
      observer?.disconnect()
      for (const element of [header, block]) {
        element.classList.remove(styles.band)
        element.style.removeProperty("--gradient-band-height")
        element.style.removeProperty("--gradient-band-offset")
      }
    }
  }, [blockRef, enabled])
}
